








































import {Vue, Component, Prop} from 'vue-property-decorator';
import MdIcon from '../../../components/vui-luma/Ui/MdIcon.vue';

@Component({
  components: {
    MdIcon,
  },
})
export default class Player extends Vue {
  @Prop({default: ''}) public srcmp4!: string;
  @Prop({default: ''}) public srcwebm!: string;
  @Prop({default: ''}) public srcogv!: string;
  @Prop({default: ''}) public image!: string;
}
